import React from "react";
import { calculateXOffset, calculateYOffset } from "../helpers/responsiveness";
import SimManager from "../managers/simManager";
import { Vector3 } from "../types";
import { SceneItemProps, SceneItemState } from "../types/SceneTypes";

class SceneItem extends React.Component<SceneItemProps, SceneItemState> {
  constructor(props: any) {
    super(props);

    this.state = {
      position: this.props.position,
      userScale: this.props.userScale,
      sceneScale: this.props.sceneScale,
      objectScale: this.props.objectScale,
      image: this.props.image,
      text: this.props.text,
      currentState: undefined,
      userInput: undefined,
      showLabel: undefined,
      hover: "",
    };
  }

  componentDidMount(): void {
    SimManager.getInstance().registerSceneObject(this);
  }

  updatePosition(newPosition: Vector3) {
    this.setState({ position: newPosition });
  }

  setScale(userScale: number, sceneScale: number) {
    this.setState({ userScale: userScale, sceneScale: sceneScale });
  }

  render() {
    const pos: React.CSSProperties = {
      top: calculateYOffset(this.state.position.y),
      left: calculateXOffset(this.state.position.x),
      position: "absolute",
      zIndex: this.props.position.z,
      scale: this.state.objectScale || 1,
    };

    return (
      <div
        style={pos}
        aria-label={this.props.alt}
        className="graphics"
        id={this.props.id}
        tabIndex={-1}
      >
        {this.state.image}
      </div>
    );
  }
}

export default SceneItem;
